<template>
<div>
  <e-chart ref="chart" @initialized="onChartInitialized" @destroy="onChartDestroy" />
</div>
</template>

<script>
import EChart from '../../../../../components/Charts/ECharts'

export default {
  name: 'FactorSourceStackPercentageChart',
  components: {EChart},
  props: {
    sourceNameConfigs: {
      required: true,
      type: Array
    },
    dataMap: {
      required: true,
      type: Object
    },
    dataTimeFormatter: {
      required: true,
      type: String
    },
    value: {
      required: true
    }
  },
  methods: {
    renderChart () {
      const {dataMap, sourceNameConfigs, dataTimeFormatter} = this
      const dataTimes = Object.keys(dataMap)
      const totalMap = dataTimes.reduce((map, dataTime) => {
        const data = dataMap[dataTime]
        map[dataTime] = sourceNameConfigs.reduce((sum, sourceNameConfig) => {
          let value = data[sourceNameConfig.id]
          return sum + (Number.isFinite(value) ? value : 0)
        }, 0)
        return map
      }, {})
      const chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 23
        },
        tooltip: {
          trigger: 'axis',
          appendToBody: true
        },
        legend: {},
        grid: {
          top: 40,
          right: 40,
          bottom: 40,
          left: 60,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: dataTimes.map(dataTime => new Date(dataTime).format(dataTimeFormatter)),
          splitLine: {
            show: false
          },
          axisLine: {
            // onZero: false
          },
          axisLabel: {
            // rotate: 90
          }
        },
        yAxis: {
          type: 'value',
          name: `%`,
          nameLocation: 'center',
          nameGap: 40,
          max: 100,
          splitLine: {
            show: false
          },
          axisLine: {
            show: true,
            onZero: false
          },
          axisTick: {
            show: true
          }
        },
        series: sourceNameConfigs.map(sourceNameConfig => ({
          name: sourceNameConfig.name,
          type: 'bar',
          color: sourceNameConfig.color,
          stack: 'source',
          barMaxWidth: 30,
          data: dataTimes.map(dataTime => {
            const data = dataMap[dataTime]
            let value = data ? data[sourceNameConfig.id] : null
            let total = totalMap[dataTime]
            return Number.isFinite(value) && total !== 0 ? Number((value / total * 100).toFixed(2)) : null
          })
        }))
      }

      this.$refs.chart.setOpt(chartOpt, true)
    },
    onChartClick (param) {
      this.$emit('input', param.name)
    },
    onChartInitialized () {
      this.$refs.chart.myChart.on('click', this.onChartClick)
      this.renderChart()
    },
    onChartDestroy () {
      this.$refs.chart.myChart.off('click', this.onChartClick)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/FactorSourceStackPercentageChart.vue